import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { IconTable } from '@rossum/ui/icons/tabler';
import { Stack, Typography } from '@rossum/ui/material';
import {
  ActivityRowLayout,
  NESTED_ROW_INDENT,
  ROW_SPACING,
  RowIcon,
  RowLabel,
  type TableRowChange,
} from '../../core';
import { FieldChangeRow } from './FieldChangeRow';

type TableChangeRowProps = {
  label: string;
  rows: TableRowChange[];
};

export const TableChangeRow = ({ label, rows }: TableChangeRowProps) => {
  const intl = useIntl();

  return (
    <Stack spacing={ROW_SPACING} data-cy="document-history-table-row">
      <ActivityRowLayout
        dataCy="document-history-table-header"
        label={<RowLabel label={label} />}
        labelIcon={<RowIcon icon={IconTable} />}
        value={null}
      />
      {rows.map(row => (
        <Fragment key={row.rowId}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={600}
            sx={{ pl: NESTED_ROW_INDENT }}
          >
            {intl.formatMessage(
              { id: 'features.documentHistory.table.row' },
              { id: row.rowId }
            )}
          </Typography>
          {row.cells.map(cell => (
            <FieldChangeRow
              key={cell.key}
              label={cell.label}
              previousValue={cell.previousValue}
              value={cell.value}
              hasIndent
            />
          ))}
        </Fragment>
      ))}
    </Stack>
  );
};
